// AutoScrollCarousel.js
import React from "react";
import styled, { keyframes } from "styled-components";

const scrollLeft = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;
const scrollRight = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0%); }
`;

const CarouselWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  padding: 1rem 0;
`;

const CarouselTrack = styled.div`
  display: flex;
  width: calc(250px * 12); /* Adjust based on number of images */
  animation: ${({ direction }) =>
      direction === "right" ? scrollRight : scrollLeft}
    10s linear infinite;
`;

const CarouselItem = styled.div`
  flex: 0 0 auto;
  width: 14rem;
  margin: ${({ idx }) =>
    idx % 2 !== 0 ? "0rem 0.5rem 1.5rem 0.5rem" : "1.5rem 0.5rem 0rem 0.5rem"};
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const images = [
  process.env.PUBLIC_URL + "/assets/landing/webImages/step1/0.png",
  process.env.PUBLIC_URL + "/assets/landing/webImages/step1/1.png",
  process.env.PUBLIC_URL + "/assets/landing/webImages/step1/2.png",
  process.env.PUBLIC_URL + "/assets/landing/webImages/step1/3.png",
  process.env.PUBLIC_URL + "/assets/landing/webImages/step1/4.png",
  process.env.PUBLIC_URL + "/assets/landing/webImages/step1/5.png",
  process.env.PUBLIC_URL + "/assets/landing/webImages/step1/6.png",
];

export default function AutoScrollCarousel({ direction }) {
  return (
    <CarouselWrapper>
      <CarouselTrack direction={direction}>
        {[...images, ...images, ...images].map((src, i) => (
          <CarouselItem key={i} idx={i}>
            <Image src={src} alt={`look-${i}`} />
          </CarouselItem>
        ))}
      </CarouselTrack>
    </CarouselWrapper>
  );
}
